import { render, staticRenderFns } from "./ClassEdit.vue?vue&type=template&id=36da4f63"
import script from "../../controllers/class/class-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/class/class-edit.js?vue&type=script&lang=js&external"
import style0 from "./ClassEdit.vue?vue&type=style&index=0&id=36da4f63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports